import React from 'react';
import styles from './PerformerNamesList.module.scss';

type PerformerNamesListProps = {
  names: string[];
  keyPrefix: 'headliner' | 'supporter';
};

export const PerformerNamesList: React.FC<PerformerNamesListProps> = ({ names, keyPrefix }) => {
  return (
    <ul className={styles.list}>
      {names.map((name, index) => (
        <li key={`${keyPrefix}-${name}-${index}`}>{name}</li>
      ))}
    </ul>
  );
};
